import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.LANDS].GET_LANDS]: {
		url: '/company/:companyId/lands/',
	},

	[ModulesConfigMap[ModulesMap.LANDS].GET_LAND]: {
		url: '/company/:companyId/lands/:landId/',
	},

	[ModulesConfigMap[ModulesMap.LANDS].GET_LAND_PREVIEW]: {
		url: '/company/:companyId/lands/:landId/preview/',
	},

	[ModulesConfigMap[ModulesMap.LANDS].GET_LAND_POPUP]: {
		url: '/company/:companyId/lands/:landId/popup/',
	},


	[ModulesConfigMap[ModulesMap.LANDS].CREATE_LAND]: {
		url: '/company/:companyId/lands/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.LANDS].PUT_LAND]: {
		url: '/company/:companyId/lands/:landId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.LANDS].PATCH_LAND]: {
		url: '/company/:companyId/lands/:landId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.LANDS].DELETE_LAND]: {
		url: '/company/:companyId/lands/:landId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}